const EXTENSION_REGEX = /\.\w{3,4}$/;

/**
 * Helper for Next.js' Image component unoptimized prop.
 *
 * Next.js' Image component doesn't support SVG images.
 * If the extension is missing it will fail those.
 * Missing extensions are mostly from bugs on file upload, so once all images have extensions this should be removed.
 */
export const shouldImageBeUnoptimized = (imageUrl: string) => !EXTENSION_REGEX.test(imageUrl);
